import React, { useState } from "react";
import { Container, Row, Col, Badge as BSBadge } from "react-bootstrap";
import "../../profileverify.css";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate, Link } from "react-router-dom";


const PROFILE = {
    id: "MTR-2024-09812",
    initials: "RK",
    name: "Rajan Kumar Subramanian",
    registered: "15 Jan 2024",
    plan: "Premium",
    age: "29 Yrs",
    height: "5'10\"",
    location: "Bengaluru, Karnataka",
    job: "Software Engineer · TCS",
    education: "B.Tech · NIT Trichy",
    tags: [
        { label: "Hindu · Brahmin (Iyer)", cls: "profileverify-ht-org" },
        { label: "Tamil", cls: "profileverify-ht-org" },
        { label: "Never Married", cls: "profileverify-ht-orng" },
        { label: "Premium Member", cls: "profileverify-ht-grn" },
        { label: "Vegetarian", cls: "profileverify-ht-org" },
    ],
    stats: [
        { num: "74", lbl: "Verification Score" },
        { num: "5/7", lbl: "Docs Uploaded" },
        { num: "88%", lbl: "Profile Complete" },
        { num: "24", lbl: "Interests Received" },
        { num: "312", lbl: "Profile Views" },
    ],
};

const PERSONAL_INFO = [
    { key: "Full Name", val: "Rajan Kumar Subramanian", badge: null },
    { key: "Date of Birth", val: "14 Mar 1995", badge: { label: "Matched", cls: "profileverify-b-grn" } },
    { key: "Gender", val: "Male", badge: null },
    { key: "Height / Weight", val: "5'10\" / 72 kg", badge: null },
    { key: "Religion / Caste", val: "Hindu · Brahmin (Iyer)", badge: null },
    { key: "Mother Tongue", val: "Tamil", badge: null },
    { key: "Marital Status", val: "Never Married", badge: null },
    { key: "Diet / Lifestyle", val: "Vegetarian · Non-smoker · Non-drinker", badge: null },
    { key: "Star / Raasi", val: "Rohini · Vrishabha", badge: null },
];

const CONTACT_INFO = [
    { key: "Mobile", val: "+91 98765 43210", badge: { label: "OTP Verified", cls: "profileverify-b-grn" } },
    { key: "Email", val: "rajan.kumar@gmail.com", badge: { label: "Verified", cls: "profileverify-b-grn" } },
    { key: "Aadhaar No.", val: "XXXX XXXX 5647", badge: { label: "Pending", cls: "profileverify-b-amb" } },
    { key: "PAN Card", val: "ABCDE1234F", badge: { label: "Verified", cls: "profileverify-b-grn" } },
    { key: "Address", val: "Koramangala, Bengaluru – 560034", badge: null },
];

const EDUCATION_INFO = [
    { key: "Highest Degree", val: "B.Tech – Computer Science", badge: { label: "Doc Verified", cls: "profileverify-b-grn" } },
    { key: "College", val: "NIT Trichy (2013–2017)", badge: null },
    { key: "Employed In", val: "Private Sector", badge: null },
    { key: "Company", val: "Tata Consultancy Services (TCS)", badge: null },
    { key: "Designation", val: "Senior Software Engineer", badge: null },
    { key: "Annual Income", val: "₹18 – 22 LPA", badge: null },
];

const DOCUMENTS = [
    {
        name: "Aadhaar Card",
        sub: "aadhaar_front.jpg · Uploaded 3 days ago",
        badge: { label: "Pending Review", cls: "profileverify-b-amb" },
        links: [
            { label: "View", color: "" },
            { label: "Approve", color: "" },
            { label: "Reject", color: "profileverify-lnk-red" },
        ],
    },
    {
        name: "PAN Card",
        sub: "pan_card.pdf · Uploaded 5 days ago",
        badge: { label: "Approved", cls: "profileverify-b-grn" },
        links: [{ label: "View", color: "" }],
    },
    {
        name: "Degree Certificate",
        sub: "btech_degree.pdf · Uploaded 5 days ago",
        badge: { label: "Approved", cls: "profileverify-b-grn" },
        links: [{ label: "View", color: "" }],
    },
    {
        name: "Horoscope / Jathakam",
        sub: "Not uploaded yet",
        badge: { label: "Missing", cls: "profileverify-b-red" },
        links: [{ label: "Request Upload", color: "profileverify-lnk-gray" }],
    },
    {
        name: "Profile Photos (2)",
        sub: "photo1.jpg, photo2.jpg · Reviewed",
        badge: { label: "Approved", cls: "profileverify-b-grn" },
        links: [{ label: "View", color: "" }],
    },
    {
        name: "Employment Proof",
        sub: "offer_letter.pdf · Under review",
        badge: { label: "In Review", cls: "profileverify-b-amb" },
        links: [
            { label: "View", color: "" },
            { label: "Approve", color: "" },
        ],
    },
];

const CHECKLIST = [
    { label: "Mobile OTP", meta: "Done", state: "grn" },
    { label: "Email verified", meta: "Done", state: "grn" },
    { label: "Aadhaar card", meta: "Pending", state: "amb" },
    { label: "PAN card", meta: "Done", state: "grn" },
    { label: "Education doc", meta: "Done", state: "grn" },
    { label: "Horoscope", meta: "Missing", state: "red" },
    { label: "Photo approved", meta: "Done", state: "grn" },
    { label: "Employment proof", meta: "In review", state: "amb" },
];

const INITIAL_LOG = [
    { type: "amb", title: "Profile submitted", sub: "by user · 3 days ago" },
    { type: "grn", title: "PAN card approved", sub: "Admin: Priya M. · 2 days ago" },
    { type: "grn", title: "Degree verified", sub: "Admin: Priya M. · 2 days ago" },
    { type: "red", title: "Aadhaar flagged", sub: "Auto system · 2 days ago" },
    { type: "gray", title: "Reminder sent to user", sub: "Horoscope upload · 1 day ago" },
];

const STATUS_STATES = [
    { cls: "profileverify-st-pending", color: "#D97706", label: "Pending Review" },
    { cls: "profileverify-st-approved", color: "#15803D", label: "Approved" },
    { cls: "profileverify-st-rejected", color: "#B91C1C", label: "Rejected" },
];


const CheckIcon = ({ stroke = "#15803D" }) => (
    <svg viewBox="0 0 12 12" fill="none">
        <path d="M2 6l3 3 5-5" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
const CrossIcon = () => (
    <svg viewBox="0 0 12 12" fill="none">
        <path d="M3 3l6 6M9 3l-6 6" stroke="#B91C1C" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);
const DotIcon = ({ fill }) => (
    <svg viewBox="0 0 12 12" fill="none">
        <circle cx="6" cy="6" r="3" fill={fill} />
    </svg>
);



const SaBadge = ({ label, cls }) => (
    <span className={`profileverify-badge ${cls}`}>{label}</span>
);

const SecIcon = ({ children }) => (
    <div className="profileverify-sec-icon">{children}</div>
);

const FieldRow = ({ fkey, val, badge }) => (
    <div className="profileverify-field-row">
        <span className="profileverify-fkey">{fkey}</span>
        <span className="profileverify-fval">
            {val}
            {badge && <SaBadge label={badge.label} cls={badge.cls} />}
        </span>
    </div>
);

const ChecklistDot = ({ state }) => {
    const clsMap = { grn: "profileverify-cd-grn", amb: "profileverify-cd-amb", red: "profileverify-cd-red" };
    const iconMap = {
        grn: <CheckIcon />,
        amb: <DotIcon fill="#D97706" />,
        red: <CrossIcon />,
    };
    return (
        <div className={`profileverify-cl-dot ${clsMap[state]}`}>
            {iconMap[state]}
        </div>
    );
};

const TimelineIcon = ({ type }) => {
    const clsMap = {
        amb: "profileverify-ti-amb",
        grn: "profileverify-ti-grn",
        red: "profileverify-ti-red",
        gray: "profileverify-ti-gray",
    };
    const iconMap = {
        amb: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path strokeLinecap="round" d="M12 8v4l3 3" />
            </svg>
        ),
        grn: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#15803D" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
        red: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#B91C1C" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
        gray: (
            <svg viewBox="0 0 24 24" fill="none" stroke="#78716C" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
        ),
    };
    return (
        <div className={`profileverify-tl-ico ${clsMap[type]}`}>
            {iconMap[type]}
        </div>
    );
};


export default function Profileverify() {
    const [statusIdx, setStatusIdx] = useState(0);
    const [score, setScore] = useState(74);
    const [dashOffset, setDashOffset] = useState(65.3);
    const [activityLog, setActivityLog] = useState(INITIAL_LOG);
    const [remark, setRemark] = useState("");

    const navigate = useNavigate();

    const status = STATUS_STATES[statusIdx];

    const cycleStatus = () => setStatusIdx((statusIdx + 1) % 3);

    const approveProfile = () => {
        setStatusIdx(1);
        setScore(96);
        setDashOffset(10);
        setActivityLog([
            { type: "grn", title: "Profile approved", sub: "Admin: You · just now" },
            ...activityLog,
        ]);
    };


    const scoreTxt = score >= 90 ? "High Confidence" : score >= 70 ? "Moderate Confidence" : "Low Confidence";

    return (
        <>


            <div className="breadcrumb-bar mb-4">
                <div className="breadcrumb-left">
                    <Link to="/admin/home" className="breadcrumb-link active">
                        Home
                    </Link>

                    <span className="breadcrumb-separator"> <IoIosArrowForward size={15} /> </span>

                    <span
                        className="breadcrumb-link inactive"
                    // onClick={() => navigate("/admin/candidate")}
                    >
                        Candidate
                    </span>
                    <span className="breadcrumb-separator"> <IoIosArrowForward size={15} /> </span>
                    <span
                        className="breadcrumb-link inactive"
                    // onClick={() => navigate("/admin/candidate")}
                    >
                        Profile verify
                    </span>
                </div>

                <button
                    className="add-outlet-btn"
                    onClick={() => navigate("/admin/candidate")}
                >
                    Candidate
                </button>
            </div>

            <Container fluid>
                <div className="profileverify-wrap">


                    <div className="profileverify-top-bar d-flex align-items-center justify-content-between">
                        <div>
                        </div>
                    </div>
                    <div className="profileverify-h">

                        <div className="profileverify-h-body">
                            {/* Avatar  <---*/}
                            <div className="profileverify-avatar-stack">
                                <div className="profileverify-avatar-main">{PROFILE.initials}</div>
                                <div className="profileverify-verified-ring" />
                                <div className="profileverify-avatar-check">
                                    <svg viewBox="0 0 12 12" fill="none" width="11" height="11">
                                        <path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </div>

                            {/*  --- > Info */}
                            <div className="profileverify-h-info">
                                <div className="profileverify-h-name">
                                    {PROFILE.name}
                                    <span className="profileverify-v-badge">
                                        <svg viewBox="0 0 12 12" fill="none" width="11" height="11">
                                            <path d="M2 6l3 3 5-5" stroke="#15803D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        Phone Verified
                                    </span>
                                </div>
                                <div className="profileverify-h-sub">
                                    <span>
                                        <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="#A8A29E" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                        {PROFILE.age}, {PROFILE.height}
                                    </span>
                                    <span>
                                        <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="#A8A29E" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        </svg>
                                        {PROFILE.location}
                                    </span>
                                    <span>
                                        <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="#A8A29E" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6a4 4 0 11-8 0 4 4 0 018 0z" />
                                        </svg>
                                        {PROFILE.job}
                                    </span>
                                    <span>
                                        <svg width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="#A8A29E" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                                        </svg>
                                        {PROFILE.education}
                                    </span>
                                </div>
                                <div className="profileverify-h-tags">
                                    {PROFILE.tags.map((t, i) => (
                                        <span key={i} className={`profileverify-htag ${t.cls}`}>{t.label}</span>
                                    ))}
                                </div>
                            </div>

                            {/* Actions  <----*/}
                            <div className="profileverify-h-actions my-3">
                                <button className="profileverify-btn profileverify-btn-approve" onClick={approveProfile}>Approve Profile</button>
                                <button className="profileverify-btn profileverify-btn-ghost">Send Correction</button>
                                <button className="profileverify-btn profileverify-btn-reject">Reject</button>
                            </div>
                        </div>

                        {/* --- > Stats Strip */}
                        <div className="profileverify-stats-strip my-2">
                            {PROFILE.stats.map((s, i) => (
                                <div key={i} className="profileverify-stat-item">
                                    <div className="profileverify-stat-num">{i === 0 ? score : s.num}</div>
                                    <div className="profileverify-stat-lbl">{s.lbl}</div>
                                </div>
                            ))}
                        </div>

                        {/* Content Grid -->  */}
                        <div className="profileverify-content">


                            <div className="profileverify-main-col">


                                <div className="profileverify-sec">
                                    <div className="profileverify-sec-head">
                                        <div className="profileverify-sec-title">
                                            <SecIcon>
                                                <svg fill="none" viewBox="0 0 24 24" stroke="#D97706" strokeWidth="2">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                </svg>
                                            </SecIcon>
                                            Personal Info
                                        </div>
                                        <SaBadge label="Verified" cls="profileverify-b-grn" />
                                    </div>
                                    <div className="profileverify-sec-body">
                                        {PERSONAL_INFO.map((f, i) => (
                                            <FieldRow key={i} fkey={f.key} val={f.val} badge={f.badge} />
                                        ))}
                                    </div>
                                </div>

                                {/* Contact & Identity <----- */}
                                <div className="profileverify-sec">
                                    <div className="profileverify-sec-head">
                                        <div className="profileverify-sec-title">
                                            <SecIcon>
                                                <svg fill="none" viewBox="0 0 24 24" stroke="#D97706" strokeWidth="2">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.948V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                </svg>
                                            </SecIcon>
                                            Contact &amp; Identity
                                        </div>
                                        <SaBadge label="Partial" cls="profileverify-b-amb" />
                                    </div>
                                    <div className="profileverify-sec-body">
                                        {CONTACT_INFO.map((f, i) => (
                                            <FieldRow key={i} fkey={f.key} val={f.val} badge={f.badge} />
                                        ))}
                                    </div>
                                </div>

                                {/* Education <- & -> Career */}
                                <div className="profileverify-sec">
                                    <div className="profileverify-sec-head">
                                        <div className="profileverify-sec-title">
                                            <SecIcon>
                                                <svg fill="none" viewBox="0 0 24 24" stroke="#D97706" strokeWidth="2">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                                                </svg>
                                            </SecIcon>
                                            Education &amp; Career
                                        </div>
                                        <SaBadge label="Verified" cls="profileverify-b-grn" />
                                    </div>
                                    <div className="profileverify-sec-body">
                                        {EDUCATION_INFO.map((f, i) => (
                                            <FieldRow key={i} fkey={f.key} val={f.val} badge={f.badge} />
                                        ))}
                                    </div>
                                </div>

                                <div className="profileverify-sec">
                                    <div className="profileverify-sec-head">
                                        <div className="profileverify-sec-title">
                                            <SecIcon>
                                                <svg fill="none" viewBox="0 0 24 24" stroke="#D97706" strokeWidth="2">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                </svg>
                                            </SecIcon>
                                            Document Verification
                                        </div>
                                        <SaBadge label="3 Pending" cls="profileverify-b-amb" />
                                    </div>
                                    <div className="profileverify-sec-body">
                                        {DOCUMENTS.map((doc, i) => (
                                            <div key={i} className="profileverify-doc-item">
                                                <div className="profileverify-doc-ico">
                                                    <svg fill="none" viewBox="0 0 24 24" stroke="#D97706" strokeWidth="2">
                                                        <rect x="3" y="3" width="18" height="18" rx="2" />
                                                        <path strokeLinecap="round" d="M7 8h10M7 12h10M7 16h6" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    <div className="profileverify-doc-name">{doc.name}</div>
                                                    <div className="profileverify-doc-sub">{doc.sub}</div>
                                                </div>
                                                <div className="profileverify-doc-right">
                                                    <SaBadge label={doc.badge.label} cls={doc.badge.cls} />
                                                    {doc.links.map((lnk, j) => (
                                                        <button
                                                            key={j}
                                                            className={`profileverify-lnk ${lnk.color || ""}`}
                                                            style={lnk.color === "profileverify-lnk-gray" ? { color: "#A8A29E" } : {}}
                                                        >
                                                            {lnk.label}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Remark Area <--- */}
                                <div className="profileverify-remark-area">
                                    <div className="profileverify-remark-label">Admin Remark / Decision Note</div>
                                    <textarea
                                        className="profileverify-textarea"
                                        placeholder="Add internal note, correction request, or rejection reason..."
                                        value={remark}
                                        onChange={e => setRemark(e.target.value)}
                                    />
                                    <div className="d-flex gap-2 flex-wrap mt-2">
                                        <button className="profileverify-btn profileverify-btn-approve" onClick={approveProfile}>
                                            Approve &amp; Publish
                                        </button>
                                        <button className="profileverify-btn profileverify-btn-ghost">Save as Draft</button>
                                        <button className="profileverify-btn profileverify-btn-reject">Reject with Reason</button>
                                        <button className="profileverify-btn profileverify-btn-ghost ms-auto">Download Report</button>
                                    </div>
                                </div>

                            </div>


                            <div className="profileverify-side-col">


                                <div className="profileverify-sec">
                                    <div className="profileverify-sec-head">
                                        <div className="profileverify-sec-title">
                                            <SecIcon>
                                                <svg fill="none" viewBox="0 0 24 24" stroke="#D97706" strokeWidth="2">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </SecIcon>
                                            Trust Score
                                        </div>
                                    </div>
                                    <div className="profileverify-score-area">
                                        <div className="profileverify-score-outer">
                                            <svg viewBox="0 0 100 100">
                                                <circle cx="50" cy="50" r="40" stroke="#FEF3C7" strokeWidth="8" />
                                                <circle
                                                    cx="50" cy="50" r="40"
                                                    stroke="#F97316" strokeWidth="8"
                                                    strokeDasharray="251.3"
                                                    strokeDashoffset={dashOffset}
                                                    style={{ transition: "stroke-dashoffset 0.6s ease" }}
                                                />
                                            </svg>
                                            <div className="profileverify-score-center">
                                                <strong>{score}</strong>
                                                <small>/ 100</small>
                                            </div>
                                        </div>
                                        <div className="profileverify-score-txt">{scoreTxt}</div>
                                        <div className="profileverify-score-sub">
                                            {score < 90 ? "Upload pending docs to raise score" : "All documents verified!"}
                                        </div>
                                    </div>
                                </div>

                                <div className="profileverify-sec">
                                    <div className="profileverify-sec-head">
                                        <div className="profileverify-sec-title">
                                            <SecIcon>
                                                <svg fill="none" viewBox="0 0 24 24" stroke="#D97706" strokeWidth="2">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                                                </svg>
                                            </SecIcon>
                                            Checklist
                                        </div>
                                    </div>
                                    <div className="profileverify-sec-body">
                                        {CHECKLIST.map((item, i) => (
                                            <div key={i} className="profileverify-cl-item">
                                                <ChecklistDot state={item.state} />
                                                <span className="profileverify-cl-lbl">{item.label}</span>
                                                <span className="profileverify-cl-meta">{item.meta}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="profileverify-sec">
                                    <div className="profileverify-sec-head">
                                        <div className="profileverify-sec-title">
                                            <SecIcon>
                                                <svg fill="none" viewBox="0 0 24 24" stroke="#D97706" strokeWidth="2">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </SecIcon>
                                            Activity Log
                                        </div>
                                    </div>
                                    <div className="profileverify-sec-body">
                                        {activityLog.map((item, i) => (
                                            <div key={i} className="profileverify-tl-item">
                                                <TimelineIcon type={item.type} />
                                                <div className="profileverify-tl-body">
                                                    <div className="sprofileverify-tl-t">{item.title}</div>
                                                    <div className="profileverify-tl-s">{item.sub}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>

                        </div>

                        {/* footer */}
                        <div className="profileverify-footer">
                            <span className="profileverify-footer-note">
                                Last reviewed by Admin: Priya Mohan · 2 days ago &nbsp;|&nbsp; Profile created: 15 Jan 2024
                            </span>
                            <button className="profileverify-btn profileverify-btn-ghost" style={{ fontSize: "12px", padding: "6px 12px" }}>
                                Flag Profile
                            </button>
                            <button className="profileverify-btn profileverify-btn-ghost" style={{ fontSize: "12px", padding: "6px 12px" }}>
                                Send Message to User
                            </button>
                        </div>

                    </div>

                </div>
            </Container>
        </>
    );
}
